module.exports = __webpack_public_path__ + "media/images/USA-bride-image1-64075e61a471678ea7db9b9af7504d74.jpg";